<div [ngClass]="{ 'avatar-container': hasBreakpoints, 'avatar-static-container': !hasBreakpoints }">
  <div class="avatar-content">
    <ng-content></ng-content>
  </div>
</div>
